import { notifications } from "@mantine/notifications";

interface NotificationProps {
    type: 'ERROR' | 'SUCCESS' | 'INFO';
    message: string;
    zIndex?: number;
    autoClose?: number | boolean;
}

export function handleNotification({ type, message, zIndex, autoClose }: NotificationProps) {
    const notificationOptions: {
        message: string;
        zIndex: number;
        position: 'top-center';
        autoClose?: number | boolean;
    } = {
        message,
        zIndex: zIndex ?? 1000,
        position: 'top-center',
        ...(autoClose !== undefined ? { autoClose } : {}),
    };

    if (type === 'SUCCESS') {
        notifications.show({
            title: "Success",
            color: 'green',
            ...notificationOptions,
        });
    } else if (type === 'ERROR') {
        notifications.show({
            title: "Error",
            color: 'red',
            ...notificationOptions,
        });
    } else {
        notifications.show({
            title: "Attention",
            color: 'orange',
            ...notificationOptions,
        });
    }
}
